import {
  BackgroundControlWithFiles,
  FindAllCompaniesResponse,
} from '@ansvar-sakerhet/api-client';

/**
 * The background controls that are deleted together with the company: only the
 * ones on the company's own project. The API returns the controls for the
 * whole client, so the file count, the file list and the delete must all use
 * this same scope.
 */
export const findCompanyBackgroundControls = (
  company: FindAllCompaniesResponse
): BackgroundControlWithFiles[] =>
  company.backgroundControls.filter(
    (control) => control.projectId === company.scopeProjectId
  );

export const countCompanyFiles = (company: FindAllCompaniesResponse) =>
  findCompanyBackgroundControls(company).reduce(
    (total, control) => total + control.reportFiles.length,
    0
  );
